export { default as LifestylesFavoriteCheckboxFilter } from './LifestylesFavoriteCheckboxFilter';
